import { useEffect, useRef, useState } from 'react';
import {
  Stack,
  Button,
  Popover,
  MenuItem,
  Container,
  Typography,
  Box,
  Modal,
  TextField,
  Grid,
} from '@mui/material';

import Iconify from '../../Components/iconify';
import axiosInstance from '../../api/axiosInstance';
import DeleteModal from '../../Components/deleteModal/DeleteModal';
import NewDevice from '../../Components/NewDevice/NewDevice';
import SnackbarComponent from '../../Components/Snackbar/Snackbar';
import { Navigate, useNavigate } from 'react-router-dom';
import plamarLogo from '../../images/palmar.png'
import serverLogo from '../../images/server.png'
import './devices.css'
import DeviceRow from '../../Components/Rows/DeviceRow';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: "4px",
  boxShadow: 24,
  p: 4,
  textAlign: "center"
};


export default function Device() {


  const [verified, setVerified] = useState(false)
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [user, setUser] = useState(null)
  const [businessId, setNewBusinessId] = useState("")
  const [loadingPage, setLoadingPage] = useState(true)
  const inputRef = useRef(null);

  useEffect(() => {
    if (sessionStorage.getItem("user")) {
      setUser(JSON.parse(sessionStorage.getItem('user')))
      sessionStorage.removeItem("user")
    }
    if (sessionStorage.getItem("businessId")) {
      setNewBusinessId(sessionStorage.getItem('businessId'))
      sessionStorage.removeItem("businessId")
    }
    setLoadingPage(false)
  }, [])

  useEffect(() => {
    if (error && password.length > 0) {
      setError(false)
    }

  }, [password])

  useEffect(() => {
    if (user && inputRef && inputRef.current) {
      inputRef.current.focus()
    }
  }, [user])

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      verifyUser(event);
    }
  };



  const verifyUser = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      return;
    }
    try {
      setLoading(true)
      const data = {
        "id": user.userid,
        "username": user.username,
        "password": password
      }
      const res = await axiosInstance.post("/user/verify", data)
      setVerified(res.data)
      if (res.data === false) {
        setError(true)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }


  const [server, setServer] = useState(null)
  const [klients, setKlients] = useState([])

  const getDevices = async () => {
    setLoading(true)
    try {
      const res = await axiosInstance.get(`/devices/${businessId}`)
      setKlients(res.data.klient)
      setServer(res.data.serveri)
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    if (verified)
      getDevices()
    //getBusiness()
  }, [verified])

  const [open, setOpen] = useState(null);



  const handleCloseMenu = () => {
    setOpen(null);
  };


  const [newDevice, setNewDevice] = useState(false);
  const [toEditRow, setToEditRow] = useState(null)
  const [tempEditData, setTempEditData] = useState(null)


  const [openSanckbar, setOpenSnackBar] = useState(false);
  const [snackbarMsgType, setSnackbarMsgType] = useState({
    message: "",
    type: ""
  })
  const [deleteModal, setDeleteModal] = useState(false)

  useEffect(() => {
    if (!deleteModal) {
      setTempEditData(null)
    }
  }, [deleteModal])

  const handleDelete = async () => {
    if (tempEditData == null) {
      return;
    }
    setDeleteModal(false)
    setOpen(null)
    try {
      await axiosInstance.delete(`/device/${tempEditData.deviceId}`)
      if (tempEditData.deviceType === 0) {
        setServer(null)
      } else {
        setKlients(klients.filter((el) => el.deviceId != tempEditData.deviceId))
      }
      setTempEditData(null)
      setDeleteModal(false)
      handleCloseMenu()
      setOpenSnackBar(true)
      setSnackbarMsgType({
        message: "Device Deleted Successfully",
        type: "success"
      })
    } catch (err) {
      console.log(err)
      setOpenSnackBar(true)
      setSnackbarMsgType({
        message: "Cant delete this device",
        type: "error"
      })
    }

  }

  const navigate = useNavigate();

  if (!loadingPage && !user) {
    return <Navigate to={"/home"} />
  }

  return (
    <>
      {
        !verified ?
          <div>
            <Modal
              open={true}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"

            >
              <Box sx={style} component={"form"} onSubmit={verifyUser}>
                <Typography sx={{ mb: 2 }} id="modal-modal-title" variant="h6" component="h2">
                  Vendos passwordin per "{user?.username}"
                </Typography>
                <Box sx={{ my: 2 }}>

                  <TextField autoFocus ref={inputRef} type='password' inputProps={{
                    autocomplete: 'new-password',
                    form: {
                      autocomplete: 'off',
                    },
                  }} value={password} onChange={e => { setPassword(e.target.value) }} onKeyDown={handleKeyDown} size='small' />
                  {
                    error ? <Typography sx={{ color: "red" }}>
                      Passwordi jo i sakte!
                    </Typography> : ""
                  }
                </Box>
                <Stack direction={"row"} justifyContent={"center"} spacing={1}>
                  <Button disabled={loading || password.length < 8} color='info' variant='contained' type='submit'>
                    OK
                  </Button>
                  <Button onClick={() => navigate('/business')} color='error' variant='contained'>
                    Cancel
                  </Button>
                </Stack>
              </Box>
            </Modal>
          </div>
          :
          <Container style={{ maxWidth: "1600px", width: "100%" }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} mt={3}>
              <Typography variant="h4" gutterBottom>
                Paisjet per {user.username}
              </Typography>
              <Button variant="contained" onClick={() => setNewDevice(true)} startIcon={<Iconify icon="eva:plus-fill" />}>
                Paisje e Re
              </Button>
            </Stack>
            <Grid container spacing={2}>
              <Grid item lg={6} md={6} sm={12} xs={12} sx={{ position: "relative" }}>

                <img src={serverLogo} height={400} style={{ width: "auto" }} />
                {
                  server ?
                    <DeviceRow type="server" server={server} el={null} i={null} setOpen={setOpen} setTempEditData={setTempEditData} />
                    : ""
                }

              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <img src={plamarLogo} style={{ width: "auto", maxHeight: "400px", marginBottom: "25px" }} />
                {
                  klients && klients.length > 0 ? klients.map((el, i) => {
                    return (
                      <DeviceRow key={i} type="klient" server={null} el={el} i={i} setOpen={setOpen} setTempEditData={setTempEditData} />
                    )
                  }) : ""
                }

              </Grid>


            </Grid>

          </Container>
      }


      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem disabled onClick={() => {
          setNewDevice(true)
          setToEditRow(tempEditData)
          handleCloseMenu()
        }}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }} onClick={() => setDeleteModal(true)}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
      {
        newDevice ? <NewDevice serverExist={server !== null} setSnackbarMsgType={setSnackbarMsgType} setOpenSnackBar={setOpenSnackBar} setOpen={setNewDevice} business={businessId} user={user} password={password} getData={getDevices} toEditRow={toEditRow} setToEditRow={setToEditRow} /> : ""
      }
      {
        deleteModal ? <DeleteModal setOpen={setDeleteModal} handleDelete={handleDelete} item="device" /> : ""
      }
      <SnackbarComponent open={openSanckbar} setOpen={setOpenSnackBar} message={snackbarMsgType.message} type={snackbarMsgType.type} />

    </>
  );
}
